import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
// import Http from '../../../../Http';

class Estadistico extends FormComponent {
  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cliente/estadistico', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Estadisticos' },
      new Form([
        Form.Field('text', 'cliente_saldo_actual', 'Saldo Atual', '', [Validators.required], 6),
        Form.Field('text', 'cliente_acumulado_anual', 'Acumulado de Consumo Anual', '', [Validators.required], 6),
        Form.Field('text', 'cliente_ultimo_envio', 'Fecha de Ultimo Envio', '', [Validators.required], 6),
        Form.Field('text', 'cliente_ultimo_pago', 'Fecha de Ultimo Pago', '', [Validators.required], 6),
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds(this.props.match.params.id)
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Estadistico)
